import { createStore } from "vuex";
import authentication from "./modules/authentication.store";
import bulletin from "./modules/bulletin.store";
import company from "./modules/company.store";
import document from "./modules/document.store";
import estate from "./modules/estate.store";
import file from "./modules/file.store";
import invitation from "./modules/invitation.store";
import notification from "./modules/notification.store";
import order from "./modules/order.store";
import product from "./modules/product.store";
import role from "./modules/role.store";
import user from "./modules/user.store";

export default createStore({
  state: {},
  mutations: {},
  actions: {
    clearAll({ commit }) {
      commit("authentication/resetState");
      commit("bulletin/resetState");
      commit("company/resetState");
      commit("document/resetState");
      commit("estate/resetState");
      commit("file/resetState");
      commit("invitation/resetState");
      commit("notification/resetState");
      commit("order/resetState");
      commit("product/resetState");
      commit("role/resetState");
      commit("user/resetState");
    },
  },
  modules: {
    authentication,
    bulletin,
    company,
    document,
    estate,
    file,
    invitation,
    notification,
    order,
    product,
    role,
    user,
  },
});
